/** @format */
import React, { FunctionComponent, useState } from 'react'
import { _$, Button, Dialog } from '@king-design/react'
interface OwnProps {
  title?: string
  children?: any
  onOk?: () => void
  content?: any
}
const DeleteConfirm: FunctionComponent<OwnProps> = ({ children, onOk, content, title }) => {
  const [show, setShow] = useState(false)
  return (
    <>
      <Dialog
        value={show}
        title={title || _$('提示')}
        onOk={() => {
          onOk && onOk()
        }}
        onChangeValue={value => {
          setShow(value)
        }}
        slotFooter={<Button onClick={() => setShow(false)}>{_$('关闭')}</Button>}
      >
        {content}
      </Dialog>
      <div
        onClick={e => {
          e.preventDefault()
          setShow(true)
        }}
      >
        {children}
      </div>
    </>
  )
}

export default DeleteConfirm
